import React, { Component } from 'react';
import { map } from 'lodash';

import { ILoanAccountActivity } from '../../../interfaces';
import { FormattingUtils } from '../../../utils';

import LoanAccountActivity from './LoanAccountActivity';

const { formatDate, formatMoney, formatPercentage, getOrDefault, varToLabel } = FormattingUtils;

// How each field the form offers reads in the entry. A field this build doesn't know about falls back
// to its own name, so an entry stays readable rather than empty if the form grows another field.
const FIELD_FORMATTERS: { [field: string]: (value: any) => string } = {
  initial_principal_amount: formatMoney,
  origination_date: formatDate,
  // The terms are recorded as the rates they ran at, one per bucket, as fractions like the API stores
  terms: (rates: string[]) => rates.map(rate => formatPercentage(rate)).join(', '),
};

const FIELD_LABELS: { [field: string]: string } = {
  contract_template: 'Contract Template',
  initial_principal_amount: 'Initial Principal',
  origination_date: 'Origination',
  terms: 'Contract Terms',
};

interface IProps {
  activity: ILoanAccountActivity;
}

/**
 * What a senior user changed on a loan, field by field. The API keeps a row-level history of its own,
 * but nothing surfaces it, so this entry is where anyone looking at the account sees that a figure its
 * balances rest on was ever anything else -- hence the old value beside the new one.
 */
class LoanEdited extends Component<IProps> {
  private renderChange (change: { from: any, to: any }, field: string) {
    const format = FIELD_FORMATTERS[field] || getOrDefault
      , label = FIELD_LABELS[field] || varToLabel(field)
      ;

    return (
      <p key={field}>
        <span className='status'>{label}:</span> {format(change.from)} &rarr; {format(change.to)}
      </p>
    );
  }

  public render () {
    const { data } = this.props.activity
      , activityBody = (
        <div>
          <h3>Loan Edited</h3>
          <p><span className='status'>Loan Id:</span> {data.loan_vanity_id}</p>
          {map(data.changes, this.renderChange)}
        </div>
      )
      ;

    // Passed explicitly rather than spread, as the other type components are
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='pencil'
      />
    );
  }
}

export default LoanEdited;
